function fromHex(hexAsString, replacementChar) {
  const hex = hexAsString.toString().toUpperCase(); //force conversion
  let str = '';
  for (let i = 0; i < hex.length; i += 2) {
    const code = hex.substring(i, i + 2);
    if (code !== '00') {
      let char;
      if (['0', '1', '8', '9'].includes(code.substring(0, 1)) || code === '7F' || code === 'A0') {
        //these are all the non-printable characters
        char = replacementChar || '';
      } else {
        char = String.fromCharCode(parseInt(code, 16));
      }
      str += char;
    }
  }
  return str;
}

function toHex(strValue, padToWord) {
  const str = strValue.toString();
  let arr = [];
  for (let i = 0, l = str.length; i < l; i++) {
    let hex = Number(str.charCodeAt(i)).toString(16);
    arr.push(hex);
  }
  if (padToWord && arr.length % 2 === 1) {
    arr.unshift('00');
  }
  return arr.join('').toUpperCase();
}

module.exports = {
  fromHex,
  toHex,
};
